import { SimulationDateString } from 'routes/HumanResourcesModule/Simulation/helpers/types';

export function getRecurrentStartAndEndDates(selectedMonth: Date | string): {
    recurrentInitialisationStartDate: SimulationDateString;
    recurrentInitialisationEndDate: SimulationDateString;
} {
    const date = new Date(selectedMonth);
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    const recurrentInitialisationStartDate: SimulationDateString = `${firstDayOfMonth.getFullYear()}-${Number(
        (firstDayOfMonth.getMonth() + 1).toString().padStart(2, '0'),
    )}-${Number(firstDayOfMonth.getDate().toString().padStart(2, '0'))}`;

    const recurrentInitialisationEndDate: SimulationDateString = `${lastDayOfMonth.getFullYear()}-${Number(
        (lastDayOfMonth.getMonth() + 1).toString().padStart(2, '0'),
    )}-${Number(lastDayOfMonth.getDate().toString().padStart(2, '0'))}`;

    return {
        recurrentInitialisationStartDate,
        recurrentInitialisationEndDate,
    };
}

export function createMonthObject(monthOffset: number): {
    label: string;
    value: SimulationDateString;
} {
    const currentDate = new Date();
    currentDate.setDate(1); // sets the day to the first day of the current month
    const targetDate = new Date(
        currentDate.setMonth(currentDate.getMonth() - monthOffset),
    );

    return {
        label: targetDate.toLocaleString('default', {
            month: 'long',
            year: 'numeric',
        }),
        value: targetDate.toISOString().slice(0, 10) as SimulationDateString,
    };
}
